import { DSNCGallery } from 'shared-definitions/types'
import { ApiComponentGallery } from 'data-source/types.wp'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

export function ncGallery(input: ApiComponentGallery, opts: PLinkMapperOpts): DSNCGallery | [] {
  const result = {
    resource: 'nc-gallery',
    items: input.images.flatMap(i => imageMapper(i, opts) ?? []),
    cols: input.columns,
  } as const

  if (result.items.length) {
    return result
  }
  return []
}
